import React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import LineGradient from '../components/LineGradient';
import { motion } from 'framer-motion';


const MySkills = () => {
  const isAboveMediumScreens = useMediaQuery("(min-width:1060px)");
  return (
    <section id='skills' className='pt-10 pb-24'>
      <div className='md:flex md:justify-between md:gap-16 mt-32'>
        <motion.div
          className='md:w-1/3'
          initial='hidden' whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 }
          }}>
          <p className='font-playfair font-semibold text-4xl mb-5'>
            MY <span className='text-red'>SKILLS</span>
          </p>
          <LineGradient className='w-1/3' />
          <p className='mt-10 m-7'>I am skilled in new and emerging technologies which includes HTML5, CSS, tailwind css,
            material UI, React, javascript, Angular, typescript and Angular material ui. Additionally, I have expertise in data analysis and data engineering tools including Excel, Power BI, SQL, and MSSQL.</p>

        </motion.div>

        <div className='mt-16 md:mt-0'>
          {isAboveMediumScreens ? (
            <div
              className="relative z-0 ml-20 before:absolute before:-top-10 before:-left-10
    before:w-full before:max-w-[400px] before:h-full before:border-2 before:border-blue before:z-[-1]"
            >
              <img
                alt="skills"
                className="z-10"
                src="assets/skills-image.png"
              />
            </div>
          ) : (<img
            alt="skills"
            className="z-10"
            src="assets/skills-image.png"
          />)}
        </div>
      </div>

      {/* skills */}

      <div className='md:flex md:justify-between mt-16 gap-32'>
        <motion.div
          className='md:w-1/3 mt-10'
          initial='hidden' whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 }
          }}>
          <div className='relative h-32'>
            <div className="z-10">
              <p className='font-playfair font-semibold text-5xl'>01</p>
              <p className='font-playfair font-semibold text-3xl mt-3'>Experience</p>
            </div>
            <div className='w-1/2 md:w-3/4 h-32 bg-blue absolute right-0 top-0 z-[-1]' />
          </div>
          <p className='mt-5'>I am skilled in new and emerging technologies which includes HTML5, CSS, tailwind css,
            material UI, React, javascript, Angular, typescript and Angular material ui. I also excel in data tools such as Excel, Power BI, SQL, and MSSQL.</p>

        </motion.div>


        {/* innovative */}
        <motion.div
          className='md:w-1/3 mt-10'
          initial='hidden' whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 }
          }}>
          <div className='relative h-32'>
            <div className="z-10">
              <p className='font-playfair font-semibold text-5xl'>02</p>
              <p className='font-playfair font-semibold text-3xl mt-3'>Innovative</p>
            </div>
            <div className='w-1/2 md:w-3/4 h-32 bg-red absolute right-0 top-0 z-[-1]' />
          </div>
          <p className='mt-5'>I constantly explore cutting-edge solutions and modern approaches to solve complex technical challenges. Whether it is optimizing database queries, building scalable React components, or creating insightful Power BI dashboards, I bring fresh perspectives and creative problem-solving to every project.</p>

        </motion.div>

            {/* IMAGINATIVE */}
            <motion.div
          className="md:w-1/3 mt-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <div className="relative h-32">
            <div className="z-10">
              <p className="font-playfair font-semibold text-5xl">03</p>
              <p className="font-playfair font-semibold text-3xl mt-3">
                Imaginative
              </p>
            </div>
            <div className="w-1/2 md:w-3/4 h-32 bg-yellow absolute right-0 top-0 z-[-1]" />
          </div>
          <p className="mt-5">
            I blend technical expertise with creative vision to craft intuitive user experiences and data-driven solutions. From designing responsive web interfaces to visualizing complex datasets in meaningful ways, I transform ideas into impactful digital products that users love.
          </p>
        </motion.div>
      </div>

    </section>
  )
}

export default MySkills
